import { DEFAULT_LOCALE } from '../../i18n/locales';

export const getRelativePathWithoutLocale = (path: string, locale: string) => {
  return locale === DEFAULT_LOCALE ? path : path.replace(/^\/[\w-]+\//u, '/');
};
